import { useSnackbar } from "notistack";

type MessageParams = {
  message?: string;
};

const useSnackbarMessage = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleError = ({ message = "Error!" }: MessageParams) => {
    enqueueSnackbar(message, {
      variant: "error",
      autoHideDuration: 2000,
      style: {
        backgroundColor: "#FFE8E8",
        color: "#15182C",
      },
    });
  };

  const handleSuccess = ({ message = "Success!" }: MessageParams) => {
    enqueueSnackbar(message, {
      variant: "success",
      autoHideDuration: 2000,
      style: {
        backgroundColor: "#EFFCF3",
        color: "#15182C",
      },
    });
  };

  return { handleError, handleSuccess };
};

export default useSnackbarMessage;
